module.exports = __webpack_public_path__ + "src/img/lightning.26c9c170.svg";